module.exports = __webpack_public_path__ + "img/icon-handyman.b2edd73a.png";